import { Component } from '@angular/core';

import { environment } from '@src/environments/environment';

@Component({
  selector: 'yt-environment-badge',
  templateUrl: './environment-badge.html',
  styleUrl: './environment-badge.scss'
})
export class EnvironmentBadge {
  readonly environmentName = environment.environmentName;
}
